<template>
  <div class="container">
    <div class="login">
      <div class="lg">
        <div class="login_main">
          <div class="login_title ft1">{{ isForce ? $t("resetPwd.force_title") : $t("resetPwd.voluntary_title") }}</div>
          <div class="blue_line"></div>
          <div class="tip">
            {{ isForce
              ? $t("resetPwd.force_tip")
              : $t("resetPwd.voluntary_tip") }}
          </div>
          <el-form
            ref="pwdForm"
            :model="pwdForm"
            :rules="rules"
            :validate-on-rule-change="false"
          >
            <el-form-item prop="pwd">
              <el-input
                v-model="pwdForm.pwd"
                :placeholder="$t('resetPwd.new_pwd_ph')"
                show-password
                maxlength="18"
                autocomplete="new-password"
              >
                <i
                  class="iconfont icon-mima el-input__icon icon_style"
                  slot="prefix"
                >
                </i>
              </el-input>
            </el-form-item>
            <el-form-item prop="rePwd">
              <el-input
                v-model="pwdForm.rePwd"
                :placeholder="$t('resetPwd.re_new_pwd_ph')"
                show-password
                maxlength="18"
                autocomplete="new-password"
              >
                <i
                  class="iconfont icon-mima el-input__icon icon_style"
                  slot="prefix"
                >
                </i>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                class="form-btn"
                block
                type="primary"
                :loading="loading"
                style="width: 100%"
                @click="submit"
                >{{ $t("public.submit") }}</el-button
              >
            </el-form-item>
          </el-form>
          <div class="logout" v-if="isForce" @click="logoutNow">
            {{ $t("resetPwd.logout_now") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { updatePwdByToken, logout } from "@/api/index";
import { sessionSnapshot, isCurrentSession, clearLoginState, logoutLocally } from '@/utils/session';
export default {
  data() {
    return {
      pwdForm: {
        pwd: "",
        rePwd: "",
      },
      loading: false,
      redirectTimer: null,
      pageActive: true,
    };
  },
  computed: {
    // 主动改密入口带 mode=voluntary，强制重置不带
    isForce() {
      return this.$route.query.mode != "voluntary";
    },
    // rules 转 computed：校验消息随语言热切换重建
    rules() {
      // 对齐后端 gf password3 规则：长度6-18且必须含大小写字母、数字、特殊字符，限可见ASCII
      const validPwd = (rule, value, callback) => {
        if (!value) {
          callback(new Error(this.$t("resetPwd.new_pwd_empty")));
        } else if (
          !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])[\x21-\x7E]{6,18}$/.test(
            value
          )
        ) {
          callback(new Error(this.$t("login.pwd_rule")));
        } else {
          callback();
        }
      };
      const validRePwd = (rule, value, callback) => {
        if (this.pwdForm.rePwd !== this.pwdForm.pwd) {
          callback(new Error(this.$t("login.pwd_mismatch")));
        } else {
          callback();
        }
      };
      return {
        pwd: [{ validator: validPwd, trigger: "blur" }],
        rePwd: [{ validator: validRePwd, trigger: "blur" }],
      };
    },
  },
  watch: {
    '$i18n.locale'() {
      // 保留输入，仅清理旧语言的校验提示
      this.$nextTick(() => {
        if (this.$refs.pwdForm) this.$refs.pwdForm.clearValidate();
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    this.pageActive = false;
    clearTimeout(this.redirectTimer);
    next();
  },
  beforeDestroy() { clearTimeout(this.redirectTimer); },
  methods: {
    submit() {
      this.$refs.pwdForm.validate((valid) => {
        if (!valid || this.loading) return;
        this.loading = true;
        const snapshot = sessionSnapshot();
        updatePwdByToken({
          userPwd: this.pwdForm.pwd,
          rePwd: this.pwdForm.rePwd,
        })
          .then((res) => {
            if (!this.pageActive || !isCurrentSession(snapshot)) return;
            if (res && res.code == 200) {
              this.$message.success(this.$t('resetPwd.success'));
              this.clearLoginState();
              localStorage.removeItem('loginAcc');
              const exited = sessionSnapshot();
              this.redirectTimer = setTimeout(() => {
                if (this.pageActive && isCurrentSession(exited)) this.$router.replace('/login');
              }, 800);
            }
          })
          .catch(() => {})
          .finally(() => { this.loading = false; });
      });
    },
    logoutNow() {
      logoutLocally(logout, () => {
        this.$store.commit('SET_LOGIN_STATUS', false);
        this.$router.replace('/login');
      }, () => this.$message.warning(this.$t('resetPwd.logout_unconfirmed')));
    },
    // 改密成功后旧 token 已被后端踢失效，本地登录态与路由缓存一并清除
    clearLoginState() {
      clearLoginState();
      this.$store.commit("SET_LOGIN_STATUS", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url("../../../src/assets/images/login/login.png");
  .login_main {
    width: 432px;
    .blue_line {
      width: 432px;
      height: 4px;
      border-radius: 5px;
      background-color: #0077ff;
      margin: 16px 0;
    }
    .tip {
      font-size: 14px;
      color: #999999;
      line-height: 22px;
      margin-bottom: 10px;
    }
    ::v-deep .el-form-item {
      margin-bottom: 28px;
    }
  }
}
.login {
  position: absolute;
  top: 0px;
  right: 0px;
  height: calc(100vh);
  width: 580px;
  background-color: rgba(240, 244, 250, 0.9);
}
.lg {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ft1 {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}
.icon_style {
  margin-left: 5px;
  color: #0077ff;
}
.logout {
  margin-top: 20px;
  font-size: 14px;
  color: #999999;
  text-align: center;
  cursor: pointer;
  &:hover {
    color: #0077ff;
  }
}
</style>
